module.exports = __webpack_public_path__ + "static/media/history_27.d6881317.jpg";